/********************** MAKE HEADER STICKY NAV BAR JS START  **********************/
// if(window.innerWidth > 1000){
//   // Get the navbar
//   const navbar = document.querySelector('.shopify-section__header');

//   if(navbar){
//       // Get the offset position of the navbar
//     const navbarOffsetTop = navbar.offsetTop;

//     // Function to handle scroll
//     function handleScroll() {
//       // console.log("offset: ", window.pageYOffset, navbarOffsetTop);
//         if (window.pageYOffset > navbarOffsetTop) {
//             navbar.classList.add('sticky-navbar');
//         } else {
//             navbar.classList.remove('sticky-navbar');
//         }
//     }

//     // Add scroll event listener
//     window.addEventListener('scroll', handleScroll);

//     // Optional: Add throttling for better performance
//     let ticking = false;

//     function throttledScroll() {
//         if (!ticking) {
//             requestAnimationFrame(() => {
//                 handleScroll();
//                 ticking = false;
//             });
//             ticking = true;
//         }
//     }

//     // Replace the simple scroll listener with throttled version for better performance
//     window.removeEventListener('scroll', handleScroll);
//     window.addEventListener('scroll', throttledScroll);

//     // Optional: Handle window resize
//     window.addEventListener('resize', () => {
//         // Recalculate offset position on resize
//         const newOffsetTop = navbar.offsetTop;
//         if (window.pageYOffset > newOffsetTop) {
//             navbar.classList.add('sticky-navbar');
//         } else {
//             navbar.classList.remove('sticky-navbar');
//         }
//     });
//   }
// }

// const navbar = document.querySelector('.shopify-section__header');

// if (navbar) {
//   let navbarOffsetTop = 0;

//   // Calculate correct offset after full load
//   function updateOffset() {
//     navbarOffsetTop = navbar.getBoundingClientRect().top + window.pageYOffset;
//   }

//   function handleScroll() {
//     if (window.pageYOffset > navbarOffsetTop) {
//       navbar.classList.add('sticky-navbar');
//     } else {
//       navbar.classList.remove('sticky-navbar');
//     }
//   }

//   // Throttle scroll (smooth performance)
//   let ticking = false;

//   function onScroll() {
//     if (!ticking) {
//       requestAnimationFrame(() => {
//         handleScroll();
//         ticking = false;
//       });
//       ticking = true;
//     }
//   }

//   // Events
//   window.addEventListener('scroll', onScroll);

//   window.addEventListener('resize', () => {
//     updateOffset();
//     handleScroll();
//   });

//   window.addEventListener('load', () => {
//     updateOffset();
//     handleScroll();
//   });
// }
// /********************** MAKE HEADER STICKY NAV BAR JS END  **********************/


// const header_effect = document.querySelector(".header--section[data-section-type='header']");

// if(header_effect){
//   window.addEventListener("scroll", () => {
//     if (window.scrollY > 50) { // add class after 50px scroll
//       header_effect.classList.add("on-scrolled");
//     } else {
//       header_effect.classList.remove("on-scrolled");
//     }
//   });
// }

const header = document.querySelector(".header--section[data-section-type='header']");

if (header) {

  function handleScroll() {
    if (window.scrollY > 50) {
      header.classList.add("sticky-navbar", "on-scrolled");
    } else {
      header.classList.remove("sticky-navbar", "on-scrolled");
    }
  }

  let ticking = false;

  window.addEventListener("scroll", () => {
    if (!ticking) {
      requestAnimationFrame(() => {
        handleScroll();
        ticking = false;
      });
      ticking = true;
    }
  });

  window.addEventListener("load", handleScroll);
}
/********************** MEGA MENU PRODUCT COLLECTION JS START  **********************/
document.addEventListener('DOMContentLoaded', function () {
    const tabButtons = document.querySelectorAll('#mega-menu-tabs .tab-btn');
    const tabContents = document.querySelectorAll('#mega-menu-tabs .tab-content');

    tabButtons.forEach((btn) => {
        btn.addEventListener('click', function () {
        // Remove active from all buttons and contents
        tabButtons.forEach((b) => b.classList.remove('active'));
        tabContents.forEach((tc) => tc.classList.remove('active'));

        // Add active to clicked button
        this.classList.add('active');

        // Show corresponding content
        let tabId = this.getAttribute('data-tab');
        document.getElementById(tabId).classList.add('active');
        });
    });
});
/********************** MEGA MENU PRODUCT COLLECTION JS END  **********************/

/********************** MEGA MENU PRODUCT COLLECTION JS START  **********************/
document.addEventListener('DOMContentLoaded', function() {
  const drawerBtn = document.getElementById('surfer--widget-toggle');
  const drawer = document.getElementById('top-rated-products-drawer');
  const drawerClose = document.getElementById('surfer--drawer-close');
  const overlayClose = document.getElementById("side-drawer-overlay");

  drawerBtn.onclick = function() {
    drawer.classList.add('open');
    if (overlayClose) overlayClose.style.display = "block";
  };
  drawerClose.onclick = function() {
    drawer.classList.remove('open');
    if (overlayClose) overlayClose.style.display = "none";
  };
  if(overlayClose){
    overlayClose.onclick = function() {
      drawer.classList.remove('open');
      if (overlayClose) overlayClose.style.display = "none";
    };
  }
  
  // Optional: close drawer when clicking outside
  window.onclick = function(event) {
    if (event.target == drawer) {
      drawer.classList.remove('open');
    }
  };
});

/********************** MEGA MENU PRODUCT COLLECTION JS END  **********************/

// var carouselElem = document.querySelector('.slideshow');

// carouselElem.addEventListener('change', function(event) {
//   console.log("Element: ",  event);
//   // Remove 'animate-in' from all cells
//   var cells = document.querySelectorAll('.carousel-cell');
//   cells.forEach(function(cell) {
//     cell.classList.remove('animate-in');
//   });

//   // Add 'animate-in' to the selected cell
//   var selectedCell = cells[flkty.selectedIndex];
//   if (selectedCell) {
//     selectedCell.classList.add('animate-in');
//   }
// });

/********************** PRODUCT COLLECTION WISHLIST JS START  **********************/

/********************** PRODUCT COLLECTION WISHLIST JS END  **********************/








// document.addEventListener('DOMContentLoaded', () => {
//   document.querySelectorAll('.surfer--product-item__image-wrapper').forEach(wrapper => {
//     const video = wrapper.querySelector('.product-hover-video');
//     if (!video) return;

//     wrapper.addEventListener('mouseenter', () => {
//       video.currentTime = 0;
//       video.play();
//     });

//     wrapper.addEventListener('mouseleave', () => {
//       video.pause();
//     });
//   });
// });




/********************** PLAY VIDEO ON HOVER ON PRODUCT JS START **********************/
// function initHoverVideos(scope = document) {
//   scope.querySelectorAll('.surfer--product-item__image-wrapper').forEach(wrapper => {
//     if (wrapper.dataset.videoInit) return;

//     const video = wrapper.querySelector('.product-hover-video');
//     if (!video) return;

//     wrapper.dataset.videoInit = 'true';

//     wrapper.addEventListener('mouseenter', () => {
//       video.currentTime = 0;
//       video.play();
//     });

//     wrapper.addEventListener('mouseleave', () => {
//       video.pause();
//     });
//   });
// }

// document.addEventListener('DOMContentLoaded', () => {
//   initHoverVideos();
// });

// const observer = new MutationObserver(mutations => {
//   mutations.forEach(mutation => {
//     mutation.addedNodes.forEach(node => {
//       if (node.nodeType === 1) {
//         initHoverVideos(node);
//       }
//     });
//   });
// });

// observer.observe(document.body, {
//   childList: true,
//   subtree: true
// });
/********************** PLAY VIDEO ON HOVER ON PRODUCT JS END **********************/



/********************** CUSTOM DISCOUNT LABEL ON SINGLE PRODUCT PAGE JS START **********************/

document.addEventListener("DOMContentLoaded", function () {

  const badge = document.querySelector('.surfer--product-discount-badge');
  console.log(badge);
  function updateDiscountBadge() {

    const activeCard = document.querySelector('.surfer--block-swatch__radio:checked');
    // const activeCard = document.querySelector('.surfer--block-swatch__radio input[type="radio"]:checked');
    
    if (!activeCard || !badge) return;

    const label = activeCard.closest('.surfer--block-swatch');

    const priceEl = label.querySelector('.price .money');
    const compareEl = label.querySelector('.compare .money');

    if (!priceEl || !compareEl) {
      badge.style.display = 'none';
      return;
    }

    const price = parseInt(priceEl.innerText.replace(/[^\d]/g, ''));
    const comparePrice = parseInt(compareEl.innerText.replace(/[^\d]/g, ''));

    if (comparePrice > price) {

      const discount = Math.round(
        ((comparePrice - price) * 100) / comparePrice
      );

      badge.innerHTML = `-${discount}% OFF`;
      badge.style.display = 'flex';

    } else {

      badge.style.display = 'none';
    }
  }

  updateDiscountBadge();

  document.querySelectorAll('.surfer--block-swatch__radio').forEach((radio) => {

    radio.addEventListener('change', function () {

      setTimeout(() => {
        updateDiscountBadge();
      }, 100);

    });

  });

});
/********************** CUSTOM DISCOUNT LABEL ON SINGLE PRODUCT PAGE JS END **********************/

if(window.location.href.includes('products')){
  const readMoreBtn = document.querySelector('.read-more-btn');
  const main_description = document.querySelector('.description');
  const description = document.querySelector('.description p');

  if(readMoreBtn){
    readMoreBtn.addEventListener('click', () => {
      main_description.classList.toggle('expanded');
      readMoreBtn.textContent = main_description.classList.contains('expanded')
        ? 'Read less'
        : 'Read more';
    });
  }
}


document.addEventListener("DOMContentLoaded", function () {

  const saveBadge = document.querySelector('.surfer--product-save-badge');

  function parsePrice(text) {
    if (!text) return 0;

    const match = text.match(/[\d,.]+/);
    if (!match) return 0;

    // keep decimal intact
    return parseFloat(match[0].replace(/,/g, ''));
  }

  function formatMoney(amount) {
    return amount.toFixed(2); // 👈 IMPORTANT FIX
  }

  function updateSaveBadge() {

    const activeCard = document.querySelector('.surfer--block-swatch__radio:checked');
    if (!activeCard || !saveBadge) return;

    const label = activeCard.closest('.surfer--block-swatch');

    const priceEl = label.querySelector('.price .money');
    const compareEl = label.querySelector('.compare .money');

    if (!priceEl || !compareEl) {
      saveBadge.style.display = 'none';
      return;
    }

    const price = parsePrice(priceEl.innerText);
    const comparePrice = parsePrice(compareEl.innerText);

    if (comparePrice > price) {

      const savings = comparePrice - price;

      saveBadge.innerHTML = `Save ₹${formatMoney(savings)}`;
      saveBadge.style.display = 'flex';

    } else {
      saveBadge.style.display = 'none';
    }
  }

  updateSaveBadge();

  document.querySelectorAll('.surfer--block-swatch__radio').forEach((radio) => {
    radio.addEventListener('change', function () {
      setTimeout(updateSaveBadge, 100);
    });
  });

});


/******* SINGLE PRODUCT PAGE OPEN FAQ QUESTIONS JS START *******/ 
document.querySelectorAll('.questions-marquee a').forEach(link => {

  link.addEventListener('click', function(e) {
    e.preventDefault();

    const targetId = this.getAttribute('href').replace('#','');
    const faqItem = document.getElementById(targetId);

    if (!faqItem) return;

    const btn = faqItem.querySelector('.surfer--faq__question');

    // close others first
    document.querySelectorAll('.surfer--faq__question[aria-expanded="true"]').forEach(b => {
      if (b !== btn) b.click();
    });

    setTimeout(() => {

      if (btn && btn.getAttribute('aria-expanded') === 'false') {
        btn.click();
      }

      faqItem.scrollIntoView({
        behavior: 'smooth',
        block: 'start'
      });

    }, 150);

  });

});
/******* SINGLE PRODUCT PAGE OPEN FAQ QUESTIONS JS END *******/ 




